import { values } from 'lodash';
import React, { useState, useEffect } from 'react';
import { Header } from 'semantic-ui-react';


const FinalTotal = ({ ...props }) => {

  const [finaltotal, setFinaltotal] = useState(0);

  useEffect(() => {
    
    if(props.subTotal){
      let total = props.subTotal -  (props?.values?.adjustmentAmount != 0 ? props.values.adjustmentAmount : 0)
      setFinaltotal(total)
    }

  }, [props.values.adjustmentAmount, props.adjustmentAmt, props.finalAmount, props.values.finalAmount, props.values.productDetails, props.subTotal, props.values.calulatedRate])

  return (
    <>
      <Header className="labelName" size="tiny">₹ {finaltotal}</Header>
    </>
  )
}

export default FinalTotal











